import { Container } from '@mui/material';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import { OrganisationSsoSettings } from '../../presentation-components/settings-components/organisation-sso-settings';

// Admin-only page under "Admin settings": configure the organisation's SSO.
export const SettingsSsoPage = () => {
  return (
    <PageOuterContainer>
      <PageHeading title="Single sign-on" hasTabs={false} />
      <Container maxWidth={false} sx={{ px: 0 }}>
        <OrganisationSsoSettings returnTo="/settings/admin-settings/single-sign-on" />
      </Container>
    </PageOuterContainer>
  );
};
